import * as Constants from './constants'

export const lichSuThanhToanListRequest = (formData) => {
  return {
    type: Constants.LSTT_LIST_REQUESTING,
    payload: formData
  }
}

export const lichSuThanhToanListSuccess = (data) => {
  return {
    type: Constants.LSTT_LIST_SUCCESS,
    data
  }
}

export const lichSuThanhToanListError = (error) => {
  return {
    type: Constants.LSTT_LIST_ERROR,
    error
  }
}

export const lichSuThanhToanExportXlsRequest = (formData, callback) => {
  return {
    type: Constants.LSTT_EXPORT_XLS_REQUESTING,
    payload: formData,
    callback
  }
}

export const lichSuThanhToanExportXlsSuccess = (data) => {
  return {
    type: Constants.LSTT_EXPORT_XLS_SUCCESS,
    data
  }
}

export const lichSuThanhToanExportXlsError = (error) => {
  return {
    type: Constants.LSTT_EXPORT_XLS_ERROR,
    error
  }
}


export const lichSuThanhToanRemoveRequest = (formData, callback) => {
  return {
    type: Constants.LSTT_REMOVE_REQUESTING,
    payload: formData,
    callback
  }
}

export const lichSuThanhToanRemoveSuccess = (response) => {
  return {
    type: Constants.LSTT_REMOVE_SUCCESS,
    payload: response
  }
}

export const lichSuThanhToanRemoveError = (error) => {
  return {
    type: Constants.LSTT_REMOVE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/LichSuThanhToan/actions.js